import { useCallback, useContext } from "react"
import { Message } from "../reducers/messagesSlice"
import { Chat } from "../reducers/chatsSlice"
import { XmppContext } from "../stream/xmppClient"
import { useAppDispatch } from "../reducers/hooks"
import useInfiniteScroll from "./useInfiniteScroll"

interface UseChatMessageFetcherReturn {
  onFetchMoreMessages: () => Promise<boolean | undefined>
}

const useChatMessageFetcher = (
  chat: Chat,
  messages: Message[],
): UseChatMessageFetcherReturn => {
  const { myJid, client } = useContext(XmppContext)
  const dispatch = useAppDispatch()
  const [, fetchMoreMessages] = useInfiniteScroll()

  const onFetchMoreMessages = useCallback(async () => {
    return await fetchMoreMessages(
      chat,
      messages,
      client,
      myJid.toString(),
      dispatch,
    )
  }, [chat, client, dispatch, fetchMoreMessages, messages, myJid])

  return {
    onFetchMoreMessages,
  }
}

export default useChatMessageFetcher
